import React from 'react';
import VocabularyRow from '../components/VocabularyRow';

const VocabulariesTableRows = ({
  category,
  items,
  columns,
}) => (
  items.map((item, index) => (
    <VocabularyRow
      key={`vocabularies_table_row_${item.id}`}
      category={category}
      vocabulary={item}
      upward={index > 4}
      columns={columns}
    />
  ))
);

export default VocabulariesTableRows;
